var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPageRotateIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 512 508.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M491.59 193.72c.87 6.92-4.03 13.24-10.95 14.12-6.91.87-13.24-4.03-14.11-10.95-3.61-28.53-15.97-53.03-34.11-71.6-17.72-18.14-41.03-30.66-67.14-35.76l12.03 20.18c3.58 5.99 1.63 13.75-4.36 17.33-5.99 3.58-13.75 1.63-17.33-4.36l-27.93-46.85c-3.52-5.88-1.72-13.53 4.11-17.19l46.16-29.12c5.91-3.71 13.72-1.94 17.43 3.96 3.72 5.91 1.94 13.72-3.96 17.43l-21.78 13.73c31.4 6.04 59.49 21.11 80.9 43.03 21.83 22.34 36.7 51.8 41.04 86.05zM149.82 508.15c-10.05 0-18.28-8.13-18.28-18.2v-75.81h20.42v73.67c71.91 0 174.74-.02 246.64-.02v-84.82c0-5.7 4.64-10.26 10.26-10.26h82.81V263.58H329.7v-20.42h164.02c10.12 0 18.28 8.17 18.28 18.28v141.53c0 3.12-1.42 5.98-3.75 7.84-10.47 10.76-91.39 97.4-97.43 97.4-76.7 0-184.27-.06-261-.06zm146.13-145.97c0 10.05-8.14 18.28-18.2 18.28H18.29C8.19 380.46 0 372.28 0 362.18V18.28C0 8.16 8.17 0 18.29 0h172.47c3.12 0 5.98 1.42 7.85 3.74l89.99 87.63c4.84 4.84 7.4 8.64 7.4 9.81 0 76.69-.05 184.27-.05 261zm-20.34-2.14c0-71.92-.03-174.75-.03-246.64h-84.82c-5.7 0-10.25-4.64-10.25-10.26V20.33H20.43v339.71h255.18z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageRotateIcon);
export default __webpack_public_path__ + "static/media/page-rotate-icon.adfc04fd9c601b9099dd5b8adee89cbd.svg";
export { ForwardRef as ReactComponent };